module.exports = __webpack_public_path__ + "static/img/withdraw_message_icon.40423e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/withdraw_message_icon.png
// module id = rdBL
// module chunks = 0